<template>
  <div class="PriceCalculationOverview">
    <card class="card">
      <table>
        <tbody>
          <tr>
            <td>
              Producten
            </td>
            <td>
              {{ (product_total && getPrice(product_total)) || "n.v.t" }}
            </td>
          </tr>
          <tr>
            <td>
              Kortingen <span v-if="coupon_code">({{ coupon_code }})</span>
            </td>
            <td>
              {{ (discounts && getPrice(discounts)) || "n.v.t" }}
            </td>
          </tr>
          <tr>
            <td>
              Verzending
            </td>
            <td>
              {{ (shipping_total && getPrice(shipping_total)) || "n.v.t" }}
            </td>
          </tr>
          <tr>
            <td>
              BTW
            </td>
            <td>
              {{ (shipping_total && getPrice(vat)) || "n.v.t" }}
            </td>
          </tr>
          <tr>
            <td>
              <span class="tot">Total</span>
            </td>
            <td>
              {{ (grand_total && getPrice(grand_total)) || "n.v.t" }}
            </td>
          </tr>
        </tbody>
      </table>
    </card>
  </div>
</template>

<script>

export default {
  props: {
    orders: Array,

    product_total: String,
    discounts: String,
    shipping_total: String,
    grand_total: String,
    coupon_code: String,
    vat: String,
  },
  methods: {
    getPrice(price) {
      return `€ ${price}`
    },
  },
  computed: {
    products() {
      return this.orders.reduce((tot, curr) => tot + curr.orders.length, 0)
    },
  },
}

</script>

<style scoped>

.PriceCalculationOverview {
  display: flex;
  justify-content: flex-end;
}

.card {
  width: 375px;
  margin-right: 16px;
  margin-top: 25px;
}

table {
  background-color: white !important;
}

.tot {
  font-weight: 700;
}

td {
  font-weight: 500;
  padding: 8px 0;
  padding-left: 39px;
}

tr + tr td {
  border-top: 1px solid rgba(230,230,230);
}

</style>
